import { request } from './client';
import type { CardTxnReport, CardTxnRow, CardTxnStart, PosBatchInput, PosBatchRow, PosTerminal, PosTerminalInput } from '@kassa/shared';

// POS terminal (KT-91).
export const posApi = {
  posTerminals: () => request<PosTerminal[]>('GET', '/api/pos/terminals'),
  posTerminalSave: (id: string | null, input: PosTerminalInput) =>
    request<PosTerminal>(id ? 'PUT' : 'POST', id ? `/api/pos/terminals/${encodeURIComponent(id)}` : '/api/pos/terminals', input),
  posForRegister: (registerId: string) =>
    request<{ terminals: PosTerminal[]; defaultTerminalId: string | null }>('GET', `/api/pos/registers/${encodeURIComponent(registerId)}/terminals`),
  posStart: (input: CardTxnStart) => request<CardTxnRow>('POST', '/api/pos/txns', input),
  posReport: (id: string, r: CardTxnReport) => request<CardTxnRow>('POST', `/api/pos/txns/${encodeURIComponent(id)}/result`, r),
  posReview: () => request<CardTxnRow[]>('GET', '/api/pos/txns/review'),
  posResolve: (id: string, r: CardTxnReport) => request<CardTxnRow>('POST', `/api/pos/txns/${encodeURIComponent(id)}/resolve`, r),
  posBatch: (terminalId: string, input: PosBatchInput) => request<PosBatchRow>('POST', `/api/pos/terminals/${encodeURIComponent(terminalId)}/batches`, input),
};
